import { CSKH_API_KEY, CSKH_ENGINE_URL } from "../env";

export const mixGetAi = async (url: string, params: any) => {
  const myHeaders = new Headers();
  myHeaders.append("x-api-key", CSKH_API_KEY);

  // Chuyển đối tượng params thành query string và gắn vào URL
  if (params && Object.keys(params).length > 0) {
    const queryString = new URLSearchParams(params).toString();
    url = url.includes("?") ? `${url}&${queryString}` : `${url}?${queryString}`;
  }

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  // Tự động thêm tiền tố /api/v1 nếu chưa có
  const path = url.startsWith("/api/v1") ? url : `/api/v1${url}`;

  const response = await fetch(`${CSKH_ENGINE_URL}${path}`, requestOptions);
  const temp = await response.json();
  return temp;
};

export const mixPostAi = async (url: string, params: any) => {
  const myHeaders = new Headers();
  myHeaders.append("x-api-key", CSKH_API_KEY);
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(params),
    redirect: "follow",
  };

  // Tự động thêm tiền tố /api/v1 nếu chưa có
  const path = url.startsWith("/api/v1") ? url : `/api/v1${url}`;

  const response = await fetch(`${CSKH_ENGINE_URL}${path}`, requestOptions);
  const temp = await response.json();
  return temp;
};
